export default __webpack_public_path__ + "static/media/blue-user-mock.b7b96140.png";